export default "__VITE_ASSET__551ad069__"